module.exports = __webpack_public_path__ + "static/media/icons.b557d0ff.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icons.ttf
// module id = 291
// module chunks = 0